import { ComponentKeyValueVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (): Promise<ComponentKeyValueVO[]> => fetcher(`/api/keyValue/userConnections`, 'GET', undefined)
